import { useState, useEffect, useCallback, startTransition } from 'react'

interface UseDisableBodyScrollOptions {
  enabled: boolean
  shouldPositionFixed?: boolean
}

export function useDisableBodyScroll({ enabled, shouldPositionFixed }: UseDisableBodyScrollOptions) {
  const [isDisabled, setIsDisabled] = useState(enabled)

  const disableBodyScroll = useCallback(() => {
    document.body.style.overflow = 'hidden'
    document.body.style.position = shouldPositionFixed ? 'fixed' : 'unset'
    document.body.style.width = '100vw'
    document.body.style.top = `-${window.scrollY}px`
    setIsDisabled(true)
  }, [shouldPositionFixed])

  const enableBodyScroll = useCallback(() => {
    document.body.style.overflow = 'unset'
    document.body.style.position = 'unset'
    document.body.style.width = 'unset'
    document.body.style.top = 'unset'
    setIsDisabled(false)
  }, [])

  useEffect(() => {
    if (enabled) {
      startTransition(() => disableBodyScroll())
    } else {
      startTransition(() => enableBodyScroll())
    }

    // Clean up the effect on unmount or when isDisabled changes
    return () => {
      startTransition(() => enableBodyScroll())
    }
  }, [enabled, disableBodyScroll, enableBodyScroll])

  return {
    isDisabled,
    disableBodyScroll,
    enableBodyScroll,
  }
}